module.exports = __webpack_public_path__ + "static/media/filter-icon.00eec4cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/filter-icon.svg
// module id = 1607
// module chunks = 0